import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen((prevMenuOpen) => !prevMenuOpen);
  };

  return (
    <div className="header">
      <div className="banner">
        <h3>CryptoLance</h3>
      </div>
      <div className="menu-icon" onClick={handleMenuToggle}>
        <i className={`fas ${menuOpen ? "fa-times" : "fa-bars"}`}></i>
      </div>
      <div className={`navbar ${menuOpen ? "active" : ""}`}>
        <ul>
          <li>
            <a href="#home">Home</a>
          </li>
          <li>
            <a href="#community">Community</a>
          </li>
          <li>
            <a href="#build">Build</a>
          </li>
          <li>
            <a href="#roadmap">Roadmap</a>
          </li>
          <li>
            <a href="#token">Token</a>
          </li>
        </ul>
      </div>
      <div className="contact">
        <a href="#contact">Contact Me</a>
      </div>
    </div>
  );
};

export default Header;
